import type { OpenPosition } from '../../api';

/** An open position copied by FXMate (FXM-04 §4): the only kind E8 lists as a card. */
export type FxmatePosition = Extract<OpenPosition, { origin: 'FXMATE' }>;

/** What E8 shows from `GET /positions`: the FXMate cards and the count of manual positions. */
export interface PositionsView {
  readonly fxmate: readonly FxmatePosition[];
  readonly manualCount: number;
}

/**
 * Splits the list into FXMate positions and a count of manual ones (spec R4, Q55: count only, as
 * on mockup 7), and sorts the FXMate ones most recently opened first (R11, proposal). A position
 * still opening has no `openedAt` yet: it is the newest, so it comes first.
 */
export function toPositionsView(positions: readonly OpenPosition[]): PositionsView {
  const fxmate: FxmatePosition[] = [];
  let manualCount = 0;
  for (const position of positions) {
    if (position.origin === 'FXMATE') fxmate.push(position);
    else manualCount += 1;
  }
  fxmate.sort(byNewestFirst);
  return { fxmate, manualCount };
}

function byNewestFirst(a: FxmatePosition, b: FxmatePosition): number {
  if (a.openedAt === b.openedAt) return 0;
  if (a.openedAt === null) return -1;
  if (b.openedAt === null) return 1;
  // ISO 8601 UTC instants: compare as times, not strings, in case the offsets differ.
  return Date.parse(b.openedAt) - Date.parse(a.openedAt);
}
